/* unplugin-vue-components disabled */import script from "./ShareCouponInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./ShareCouponInfo.vue?vue&type=script&setup=true&lang=js"

import "./ShareCouponInfo.vue?vue&type=style&index=0&id=a24c830a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a24c830a"]])

export default __exports__